import React from 'react';
import PropTypes from 'prop-types';
import { 
  formatDateToISO, 
  getCalendarDays 
} from './calendarUtils';

function CalendarDays(props) {
  const {
    day,
    BiweeklyDate,
    lastWeekDay,
    changedDates,
    currentPath,
    compare,
    changeCurrentDay
  } = props;

  const biweeklyDates = formatDateToISO(BiweeklyDate || '2024-07-01');
  const lastWeekDates = formatDateToISO(lastWeekDay || new Date());
  const currentDay = formatDateToISO(changedDates.currentDay);
  const endDay = formatDateToISO(changedDates.endDay);

  const calendarDays = getCalendarDays(day, {
    biweeklyDates,
    lastWeekDates,
    currentPath,
    changedDates,
    compare,
    currentDay,
    endDay
  });

  const getDayClassName = (day) => {
    const classes = ['calendar-day'];
    
    if (day.currentMonth) classes.push('current');
    if (day.selected) classes.push('selected', 'no-disabled');
    if (day.disabled) classes.push('disabled');
    if (day.compare) classes.push('compare', 'no-disabled');
    
    return classes.join(' ');
  };

  const getDayStyle = (day) => {
    return !day.number ? { pointerEvents: 'none' } : {};
  };

  return (
    <div className="table-content">
      {calendarDays.map((day, index) => (
        <div
          key={`${day.year}-${day.month}-${day.number}-${index}`}
          style={getDayStyle(day)}
          className={getDayClassName(day)}
          onClick={() => changeCurrentDay(day)}
        >
          <p>{day.number}</p>
        </div>
      ))}
    </div>
  );
}

CalendarDays.propTypes = {
  day: PropTypes.instanceOf(Date).isRequired,
  BiweeklyDate: PropTypes.string,
  lastWeekDay: PropTypes.instanceOf(Date),
  changedDates: PropTypes.shape({
    currentDay: PropTypes.instanceOf(Date),
    endDay: PropTypes.instanceOf(Date)
  }).isRequired,
  currentPath: PropTypes.string,
  compare: PropTypes.bool,
  changeCurrentDay: PropTypes.func.isRequired
};

CalendarDays.defaultProps = {
  BiweeklyDate: '2024-07-01',
  lastWeekDay: new Date(),
  currentPath: '',
  compare: false
};

export default CalendarDays;